import { t } from '@transifex/native';
import { useTX } from '@transifex/react';
import { cn } from '~/lib/utils';
import { StarIcon } from '~/components/ui/gamification/icons/star-rating';

const STATS_CONFIG = {
  login: {
    icon: '/assets/gamification/daily-login.svg',
    getLabel: (value: string) => t('Daily login status: {value}', { value }),
  },
  xp: {
    icon: '/assets/gamification/xp.svg',
    getLabel: (value: string) => t('Total XP: {value}', { value }),
  },
  stars: {
    getLabel: (value: string) => t('Total stars: {value}', { value }),
  },
} as const;

type GameStatsProps = {
  type: keyof typeof STATS_CONFIG;
  value: number;
  maxValue?: number;
  className?: string;
};

export function GameStats({ type, value, maxValue, className }: GameStatsProps) {
  const tx = useTX();
  const locale = tx.getCurrentLocale() || undefined;

  const displayValue =
    maxValue != null
      ? `${Math.max(0, Math.min(value, maxValue))}/${maxValue}`
      : value.toLocaleString(locale);

  const { getLabel } = STATS_CONFIG[type];

  return (
    <span
      className={cn(
        `
          inline-flex h-8 items-center justify-center gap-xs overflow-hidden
          rounded-full px-xs text-body-small
        `,
        className
      )}
      role="status"
      aria-label={getLabel(displayValue)}
    >
      {type === 'stars' ? (
        <StarIcon state="filled" size="xs" className="size-5" />
      ) : (
        <img src={STATS_CONFIG[type].icon} alt="" className="size-5 shrink-0" aria-hidden="true" />
      )}
      <span className="text-text-900">{displayValue}</span>
    </span>
  );
}
